enum Devices {
  mobile = "screen and (max-width: 480px)",
  tablet = "screen and (max-width: 767px)",
  desktop = "screen and (max-width: 992px)",
}

export default Devices;
